import React, { useState } from 'react';
import { Input, Button, Card, message, Spin, Empty } from 'antd';
import { SearchOutlined, EyeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { workflowAPI } from '../services/api';

const { Search } = Input;

const WorkflowQuickSearch = () => {
  const [searchValue, setSearchValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [searchResult, setSearchResult] = useState(null);
  const [hasSearched, setHasSearched] = useState(false);
  const navigate = useNavigate();

  // 处理搜索
  const handleSearch = async (value) => {
    if (!value.trim()) {
      message.warning('请输入工作流编号');
      return;
    }

    try {
      setLoading(true);
      setHasSearched(true);
      
      const response = await workflowAPI.searchWorkflowByNum(value.trim());
      
      if (response.success) {
        setSearchResult(response.data);
        message.success('搜索成功');
      } else {
        setSearchResult(null);
        message.error('未找到指定编号的工作流');
      }
    } catch (error) {
      console.error('搜索工作流失败:', error);
      setSearchResult(null);
      if (error.message && error.message.includes('404')) {
        message.error('未找到指定编号的工作流');
      } else {
        message.error('搜索失败: ' + (error.message || '未知错误'));
      }
    } finally {
      setLoading(false);
    }
  };

  // 查看工作流详情
  const handleViewWorkflow = (workflowNum) => {
    navigate(`/workflow/${workflowNum}`);
  };

  // 清空搜索结果
  const handleClear = () => {
    setSearchResult(null);
    setHasSearched(false);
    setSearchValue('');
  };

  return (
    <div style={{ padding: '20px' }}>
      <Card 
        title="工作流快速搜索" 
        extra={
          hasSearched && (
            <Button onClick={handleClear}>
              清空结果
            </Button>
          )
        }
      >
        <div style={{ marginBottom: '20px' }}>
          <Search
            placeholder="请输入工作流编号进行精确搜索"
            enterButton={<SearchOutlined />}
            size="large"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onSearch={handleSearch}
            loading={loading}
            allowClear
          />
        </div>

        <Spin spinning={loading}>
          {hasSearched && (
            <>
              {searchResult ? (
                <Card 
                  hoverable
                  style={{ marginTop: '16px' }}
                  cover={
                    searchResult.cover_image ? (
                      <img
                        alt="工作流封面"
                        src={searchResult.cover_image}
                        style={{ 
                          height: 200, 
                          objectFit: 'cover',
                          width: '100%'
                        }}
                      />
                    ) : (
                      <div 
                        style={{ 
                          height: 200, 
                          backgroundColor: '#f5f5f5',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#999'
                        }}
                      >
                        <EyeOutlined style={{ fontSize: '48px' }} />
                      </div>
                    )
                  }
                  actions={[
                    <Button 
                      type="primary" 
                      onClick={() => handleViewWorkflow(searchResult.workflow_num)}
                      key="view"
                    >
                      查看/编辑工作流
                    </Button>
                  ]}
                >
                  <Card.Meta
                    title={`工作流编号: ${searchResult.workflow_num}`}
                    description={
                      <div>
                        <p><strong>名称:</strong> {searchResult.workflow_name}</p>
                        <p><strong>创建时间:</strong> {new Date(searchResult.created_at).toLocaleString()}</p>
                        <p><strong>更新时间:</strong> {new Date(searchResult.updated_at).toLocaleString()}</p>
                      </div>
                    }
                  />
                </Card>
              ) : (
                <Empty 
                  description="未找到匹配的工作流"
                  style={{ marginTop: '40px' }}
                />
              )}
            </>
          )}
        </Spin>
      </Card>
    </div>
  );
};

export default WorkflowQuickSearch; 